// extracted by mini-css-extract-plugin
export var animationContainer = "_hr-0";
export var asteriskIcon = "_hr-8";
export var conversationLeftSection = "_hr-4";
export var conversationListItem = "_hr-3";
export var conversationMiddleSection = "_hr-5";
export var conversationRightSection = "_hr-6";
export var detailsContent = "_hr-1";
export var listContainer = "_hr-7";
export var modalContent = "_hr-2";